import { useEffect, useState } from "react";
import { HorizontalLayout, VerticalLayout } from "./layout";
import { deleteAPI, getAPI, postAPI } from "../api/api";
import { ButtonGroup, StandardButton } from "../atoms/buttons";
import { icon } from "../functions/icons";
import { Modal, ModalBody, ModalTitle } from "./modal";
import { InputForm } from "../atoms/input";
import { AddBusinessModal } from "./customModals";
import { Alert } from "./alert";
import { SettingsHeader } from "../molecule/settingsHeader";

export const CustomerSettings = () => {
  const [customers, setCustomers] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [modal, setModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [removeModal, setRemoveModal] = useState(false);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [newCompanyName, setNewCompanyName] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    loadCustomers();
  }, []);

  const loadCustomers = async () => {
    const query = `api/business/customers`;
    const response = await getAPI(query);
    setCustomers(response.data || []);
  };

  const addUserModal = () => {
    setErrorMessage("");
    setModal(!modal);
  };

  const editCompanyModal = (company) => {
    setSelectedCompany(company);
    setNewCompanyName(company.name);
    setEditModal(true);
  };

  const removeCompanyModal = (company) => {
    setSelectedCompany(company);
    setRemoveModal(true);
  };

  const handleEditCompany = async () => {
    if (!newCompanyName.trim()) {
      setErrorMessage("Bedrijfsnaam kan niet leeg zijn.");
      setTimeout(() => setErrorMessage(""), 2000);
      return;
    }
    const response = await postAPI("api/business/edit-business", {
      id_business: selectedCompany.id_business,
      new_name: newCompanyName.trim(),
    });

    if (response.status === "ok") {
      loadCustomers();
      setEditModal(false);
    } else {
      setErrorMessage(response.message || "Fout bij bewerken bedrijf.");
      setTimeout(() => setErrorMessage(""), 2000);
    }
  };

  const handleRemoveCompany = async () => {
    if (selectedCompany) {
        const response = await deleteAPI("api/business/remove-business",
        {
          id_business: selectedCompany.id_business,
          
        });

        if (response.status === "ok") {
          console.log(response.status);
          loadCustomers();
          setRemoveModal(false);
        } else {
          setErrorMessage(response.message || "Fout bij verwijderen bedrijf.");
          console.log(response.message);
          setTimeout(() => setErrorMessage(""), 2000);
        }
    
    }
  };

  return (
    <VerticalLayout className="settings-card">

      <SettingsHeader
        title={"Klantenbeheer"}
        description={"Maak hier nieuwe klanten aan"}
        toggleAddModal={addUserModal}
      />

      <VerticalLayout className="settings-rows" style={{ margin: "0rem", marginTop: "unset",padding:"1rem", width:"unset", paddingTop:0 }}>
        <VerticalLayout
          style={{
            boxSizing: "border-box",
            borderColor: "var(--border-color)",
            borderRadius: "0.5rem",
            borderWidth:"1px",
            borderStyle: "solid",
            overflow:"hidden",
            
          }}
        >
          {isLoading ? (
            <p>Bezig met laden...</p>
          ) : customers.length > 0 ? (
            customers.map((company) => (
              <BusinessComp
                key={company.id_business}
                editCompany={editCompanyModal}
                removeCompany={removeCompanyModal}
                company={company}
              />
            ))
          ) : (
            <p className="standard-padding">Geen klanten gekoppeld.</p>
          )}
        </VerticalLayout>
      </VerticalLayout>
      <AddBusinessModal
        dismiss={addUserModal}
        visible={modal}
        loadCustomers={loadCustomers}
      />
      <DynamicModal
        visible={editModal}
        dismiss={() => setEditModal(false)}
        title="Bedrijf bewerken"
        content={
          <>
            <InputForm
              value={newCompanyName}
              typeInput={setNewCompanyName}
              placeholder="Nieuwe bedrijfsnaam"
            />
            {errorMessage && (
              <Alert marginTop={"1rem"} type={"error"} message={errorMessage} />
            )}
          </>
        }
        actions={{
          cancel: () => setEditModal(false),
          submit: handleEditCompany,
          submitTitle: "Opslaan",
        }}
      />
      <DynamicModal
        visible={removeModal}
        dismiss={() => setRemoveModal(false)}
        title="Bedrijf verwijderen"
        content={
          <>
            <p>
              Weet je zeker dat je het bedrijf{" "}
              <strong>{selectedCompany?.name}</strong> wilt verwijderen?
            </p>
            {errorMessage && (
              <Alert marginTop={"1rem"} type={"error"} message={errorMessage} />
            )}
          </>
        }
        actions={{
          cancel: () => setRemoveModal(false),
          submit: handleRemoveCompany,
          submitTitle: "Verwijderen",
        }}
      />
    </VerticalLayout>
  );
};

const BusinessComp = ({ editCompany, removeCompany, company }) => {
  return (
    <div className="employee-comp">
      <div style={{ flexGrow: 1, display: "flex", flexDirection: "row" }}>
        <p className="employee-name" style={{ display: "flex", gap: "0.5rem" }}>
          {company.name}
        </p>
      </div>
      <div className="employee-actions" style={{ textAlign: "right" }}>
        <ButtonGroup
          buttons={[
            {
              id: "edit01",
              onClick: () => editCompany(company),
              content: <>{icon("edit")}</>,
            },
            {
              id: "remove01",
              onClick: () => removeCompany(company),
              content: <>{icon("trash")}</>,
            },
          ]}
        />
      </div>
    </div>
  );
};

const DynamicModal = ({ visible, dismiss, title, content, actions }) => (
  <Modal
    visible={visible}
    dismissable={dismiss}
    content={
      <>
        <ModalTitle title={title} hasXmark dismissable={dismiss} />
        <ModalBody>
          {content}
          <ModalActions
            onCancel={actions.cancel}
            onSubmit={actions.submit}
            submitTitle={actions.submitTitle}
          />
        </ModalBody>
      </>
    }
  />
);

const ModalActions = ({ onCancel, onSubmit, submitTitle }) => (
  <HorizontalLayout className="space-between standard-margin-top">
    <StandardButton onClick={onCancel} title="Annuleren" />
    <StandardButton onClick={onSubmit} title={submitTitle} />
  </HorizontalLayout>
);
